/* Layout */
import Layout from '../../views/layout/Layout.vue'

export default [
  {
    path: '/memberships',
    component: Layout,
    redirect: 'noredirect',
    name: 'memberships',
    alwaysShow: true,
    meta: {
      title: 'goxipCircle',
      icon: ['far', 'circle'],
    },
    children: [
      {
        path: 'daily-opt-in',
        component: () => import(/* webpackChunkName: "memberships-daily-opt-in" */ '@/views/memberships/GoxipCircleDailyOptIn'),
        name: 'dailyOptIn',
        meta: {
          title: 'dailyOptIn',
          icon: ['fas', 'list'],
          accessibleName: 'memberships-daily-opt-in',
        },
      },
      {
        path: 'point-status',
        component: () => import(/* webpackChunkName: "memberships-point-status" */ '@/views/memberships/GoxipCirclePointStatus'),
        name: 'pointStatus',
        meta: {
          title: 'pointStatus',
          icon: ['fas', 'list'],
          accessibleName: 'memberships-point-status',
        },
      },
      {
        path: 'rewards',
        component: () => import(/* webpackChunkName: "memberships-rewards" */ '@/views/memberships/GoxipCircleRewardList'),
        name: 'rewards',
        meta: {
          title: 'rewards',
          icon: ['fas', 'gift'],
          accessibleName: 'memberships-rewards',
        },
      },
      {
        path: 'order-appeal',
        component: () => import(/* webpackChunkName: "memberships-order-appeal" */ '@/views/memberships/GoxipCircleOrderAppealList'),
        name: 'orderAppeal',
        meta: {
          title: 'orderAppeal',
          icon: ['far', 'flag'],
          accessibleName: 'order-appeal',
        },
      },
    ],
  },
]
